










































































































































































































































































































































import centro_trabajoModule from "@/store/modules/centro_trabajo-module";
import tipos_fichajeModule from "@/store/modules/tipos_fichaje-module";
import usuarioModule from "@/store/modules/usuario-module";
import variablesModule from "@/store/modules/variablesModule";
import { Component, Vue } from "vue-property-decorator";
import fichajes_empleadoModule from "@/store/modules/fichajes_empleado-module";
import { fichajes_empleado } from "@/shared/dtos/fichajes_empleado";
import { MessageService } from "@/shared/services/message-service";
import { API } from "@/shared/api";
@Component({
  components: {},
})
export default class configuracion_turnos extends Vue {
  public selectedEmployees: number[] = [];
  public dateRange = {
    start: "",
    end: "",
  };

  public employees: { id: number; name: string }[] = [];

  public label_centros_trabajo: string = "Centro trabajo";
  public projects: { id: number; name: string }[] = [];

  public attendanceTypes: { id: number; name: string }[] = [];
  public copiedBlocks: any[] | null = null;

  public weekDays: any[] = [];

  public previewFichajes: fichajes_empleado[] = [];
  public showPreview: boolean = false;

  created() {
    usuarioModule.getusuarios().then(() => {
      this.employees = usuarioModule.usuarios.map((emp) => ({
        id: emp.id,
        name: `${emp.nombre}`,
      }));
    });

    tipos_fichajeModule.gettipos_fichajes().then(() => {
      this.attendanceTypes = tipos_fichajeModule.tipos_fichajes.map((emp) => ({
        id: emp.id,
        name: `${emp.nombre}`,
      }));
    });
    variablesModule.getVariable("centros_trabajo").then((x: string) => {
      this.label_centros_trabajo = x;
    });

    centro_trabajoModule.getcentro_trabajos_base().then(() => {
      this.projects = centro_trabajoModule.centro_trabajos.map((emp) => ({
        id: emp.id,
        name: `${emp.nombre}`,
      }));
    });

    setTimeout(() => {
      this.initializeWeekDays();
    }, 1000);
  }

  public initializeWeekDays(): void {
    const names = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];
    this.weekDays = names.map((name) => ({
      name: name,
      enabled: false,
      blocks: [this.createDefaultBlock()],
    }));
  }

  public createDefaultBlock() {
    return {
      timeFrom: "08:00",
      timeTo: "14:00",
      type: this.attendanceTypes.length > 0 ? this.attendanceTypes[0].id : null,
      project: this.projects.length > 0 ? this.projects[0].id : null,
    };
  }

  get isFormValid(): boolean {
    let anyEnabled = false;
    for (let i = 0; i < this.weekDays.length; i++) {
      if (this.weekDays[i].enabled) {
        anyEnabled = true;
        break;
      }
    }

    return (
      this.selectedEmployees.length > 0 &&
      this.dateRange.start !== "" &&
      this.dateRange.end !== "" &&
      anyEnabled
    );
  }

  public addBlock(dayIndex: number): void {
    this.weekDays[dayIndex].blocks.push(this.createDefaultBlock());
  }

  public removeBlock(dayIndex: number, blockIndex: number): void {
    this.weekDays[dayIndex].blocks.splice(blockIndex, 1);
  }

  public removeEmployee(employeeId: number): void {
    const index = this.selectedEmployees.indexOf(employeeId);
    if (index > -1) {
      this.selectedEmployees.splice(index, 1);
    }
  }

  public resetForm(): void {
    this.selectedEmployees = [];
    this.dateRange = { start: "", end: "" };
    this.initializeWeekDays();
  }

  public saveConfiguration(): void {
    const filteredWeekDays = [];
    for (let i = 0; i < this.weekDays.length; i++) {
      const day = this.weekDays[i];
      if (day.enabled) {
        const validBlocks = [];
        for (let j = 0; j < day.blocks.length; j++) {
          const block = day.blocks[j];
          if (block.timeFrom && block.timeTo) {
            validBlocks.push(block);
          }
        }
        filteredWeekDays.push({
          name: day.name,
          enabled: day.enabled,
          blocks: validBlocks,
        });
      }
    }

    const configuration = {
      employees: this.selectedEmployees,
      dateRange: this.dateRange,
      weekDays: filteredWeekDays,
    };

    this.$emit("configuration-saved", configuration);

    this.$nextTick(() => {
      this.SaveFichajes();
    });
  }

  public SaveFichajes(): void {
    const fichajes: fichajes_empleado[] = [];

    for (let i = 0; i < this.selectedEmployees.length; i++) {
      const empleadoId = this.selectedEmployees[i];

      for (let j = 0; j < this.weekDays.length; j++) {
        const dia = this.weekDays[j];
        if (!dia.enabled) {
          continue;
        }

        for (let k = 0; k < dia.blocks.length; k++) {
          const bloque = dia.blocks[k];

          if (bloque.timeFrom && bloque.timeTo) {
            const fechaInicio = new Date(this.dateRange.start);
            const fechaFin = new Date(this.dateRange.end);

            // Se generan fichajes por cada día entre start y end si coincide con el nombre del día
            const fechaActual = new Date(fechaInicio);
            while (fechaActual <= fechaFin) {
              const diaSemana = fechaActual.getDay(); // 0 = domingo, 1 = lunes, etc.
              const nombreSemana = [
                "Domingo",
                "Lunes",
                "Martes",
                "Miércoles",
                "Jueves",
                "Viernes",
                "Sábado",
              ][diaSemana];

              if (nombreSemana === dia.name) {
                const fechaEntrada = new Date(fechaActual);
                const horaDesde = bloque.timeFrom.split(":");
                fechaEntrada.setHours(parseInt(horaDesde[0], 10));
                fechaEntrada.setMinutes(parseInt(horaDesde[1], 10));
                // Poner segundos aleatorios entre 0 y 59
                fechaEntrada.setSeconds(Math.floor(Math.random() * 60));

                const fechaSalida = new Date(fechaActual);
                const horaHasta = bloque.timeTo.split(":");
                fechaSalida.setHours(parseInt(horaHasta[0], 10));
                fechaSalida.setMinutes(parseInt(horaHasta[1], 10));
                // Poner segundos aleatorios entre 0 y 59
                fechaSalida.setSeconds(Math.floor(Math.random() * 60));

                // Aplicar desviación aleatoria
                const entradaConVariacion = this.applyRandomOffset(
                  fechaEntrada
                );
                const salidaConVariacion = this.applyRandomOffset(fechaSalida);
                // Crear el objeto fichaje
                const nuevo = new fichajes_empleado();
                nuevo.fecha_entrada = entradaConVariacion;
                nuevo.fecha_salida = salidaConVariacion;
                nuevo.id_tipo_fichaje = bloque.type;
                nuevo.id_usuario = empleadoId;
                nuevo.id_centro_trabajo = bloque.project;
                nuevo.id = 0; 

                fichajes.push(nuevo);
              }

              fechaActual.setDate(fechaActual.getDate() + 1);
            }
          }
        }
      }
    }

    if (fichajes.length === 0) {
      alert("No se generaron fichajes.");
      return;
    }
    // Ordenar por fecha_entrada y luego por id_usuario
    this.previewFichajes = fichajes.sort((a, b) => {
      // Primero por id_usuario (empleado)
      if ((a.id_usuario || 0) !== (b.id_usuario || 0)) {
        return (a.id_usuario || 0) - (b.id_usuario || 0);
      }
      // Luego por fecha_entrada
      const fechaA = a.fecha_entrada.getTime();
      const fechaB = b.fecha_entrada.getTime();
      return fechaA - fechaB;
    });
    this.showPreview = true;

    // Guardar los fichajes
    /*  Promise.all(
      fichajes.map((f) => fichajes_empleadoModule.guardarfichajes_empleado(f))
    )
      .then(() => {
        alert("Fichajes guardados exitosamente.");
        this.resetForm();
      })
      .catch((err) => {
        console.error("Error al guardar fichajes:", err);
        alert("Error al guardar algunos fichajes.");
      });*/
  }
  private applyRandomOffset(date: Date): Date {
    const offset = Math.floor(Math.random() * 11) - 5; // entre -5 y +5
    const newDate = new Date(date);
    newDate.setMinutes(newDate.getMinutes() + offset);
    return newDate;
  }
  public removePreviewFichaje(index: number): void {
    MessageService.confirm(
      "¿Seguro que quiere eliminar el registro ?",
      "Eliminar",
      (x: boolean) => {
        if (x) {
          this.previewFichajes.splice(index, 1);
        }
      }
    );
  }
  public confirmarYGuardar(): void {
    fichajes_empleadoModule
      .guardarfichajes_masivos_avanzado(this.previewFichajes)
      .then(() => {
        MessageService.toastsuccesful("Fichajes guardados correctamente");
        this.resetForm();
        this.showPreview = false;
      })
      .catch((err) => {
        console.error("Error al guardar fichajes:", err);
        MessageService.toast("rror al guardar algunos fichajes.", "Error");
        this.showPreview = false;
      });
  }
  private datetimeLocalValue(date: Date): string {
    if (!(date instanceof Date)) return "";
    const pad = (n: number) => (n < 10 ? "0" + n : n);
    const yyyy = date.getFullYear();
    const MM = pad(date.getMonth() + 1);
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());
    return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}`;
  }

  private parseDatetimeLocal(value: string): Date {
    return new Date(value);
  }

  public getImagen(id_numero: number): string {
    return API.webApiBaseImages + id_numero + ".png";
  }

  public copyBlocks(dayIndex: number): void {
    this.copiedBlocks = JSON.parse(
      JSON.stringify(this.weekDays[dayIndex].blocks)
    );
  }

  public pasteBlocks(dayIndex: number): void {
    if (this.copiedBlocks) {
      this.weekDays[dayIndex].blocks = JSON.parse(
        JSON.stringify(this.copiedBlocks)
      );
      this.weekDays[dayIndex].enabled = true;
    }
  }
}
